module.exports = __webpack_public_path__ + "img/arrow_left_circle.40667c7c.svg";